export default __webpack_public_path__ + "static/Dzung_Nguyen-d3b5b738b7d161c9fdf4e62a69b8f1c0.png";